import { render } from "./NewFileTabTour.vue?vue&type=template&id=a5c94f04"
import script from "./NewFileTabTour.vue?vue&type=script&lang=js"
export * from "./NewFileTabTour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__